import { render, staticRenderFns } from "./TableDespesa.vue?vue&type=template&id=955ff56c"
import script from "./TableDespesa.vue?vue&type=script&lang=js"
export * from "./TableDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports